module.exports = __webpack_public_path__ + "ui-icons_ffffff_256x240.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery-ui/themes/base/images/ui-icons_ffffff_256x240.png
// module id = 766
// module chunks = 1